<template lang="html">
  <v-app class="large-screen__body white">
    <topbar v-if="activeTabbar === 'chat'" class='fixed-nav'></topbar>
    <div :class="{'fixed-top': activeTabbar === 'chat'}">
      <v-toolbar flat>
        <!-- left icons -->
        <div class="back-button-toolbar">
          <v-btn icon class="toolbar-button" @click="goBack()">
              <img src="~icons/backIcon/backIcon.png" alt="backIcon">
          </v-btn>
        </div>
        <v-spacer></v-spacer>
        <!-- center text -->
        <v-toolbar-title class="white--text">
          {{ project.project_name }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon class="toolbar-button">
          <img src="~icons/moreIcon/moreIcon.png" alt="moreIcon">
        </v-btn>
      </v-toolbar>

       <!-- tabs -->
      <v-tabs grow centered class="primary-tabs white--text">
       <v-tab :to="{ name: 'ProjectOverview' }" :href="`#overview`" class="white--text">
         Overview
       </v-tab>
       <v-tab :to="{ name: 'ProjectTasks' }" :href="`#tasks`" class="white--text">
         Effort
       </v-tab>
       <v-tab :to="{ name: 'ProjectChat' }" :href="`#chat`" class="white--text">
         Chat
       </v-tab>
      </v-tabs>
    </div>

    <v-tabs-items v-model="activeTabbar">
      <v-tab-item :id="`overview`"  class="body">
        <div class="project-name">
          {{ project.project_name }}
        </div>

        <div class="project-description">
          <div v-if="project.project_description"><vue-markdown>{{ project.project_description }}</vue-markdown></div>
        </div>
        <div>
          <v-btn flat  small class="edit"><span>Show Additional information</span></v-btn>
        </div>
        <div class="contributors-area">
          <div style="display:inline-flex;">
            <span v-for="item in contributors.slice(0,5)"><img :src="item.avatar" :key="item.user_id"></span>
            <div v-if="contributors.length>5" class="left-contributors white--text"><span>+{{ contributors.length - 5 }}</span></div>
            <v-btn v-if="this.contributors.length>0" flat class="all-contributors-btn">
              <span>All Contributors</span>
            </v-btn>
          </div>
        </div>
        <div>
          <span @click="showGallery(index)" class="image-list" v-for="(image, index) in projectMedia" :key="image.data_object_id">
            <imager :src="createThumbnailUrl(image.data_url)" :styles="{'min-width': '124px', 'max-height': '124px'}">
              <loader></loader>
            </imager>
            <a :href="image.data_url" download target="_blank">
              <v-btn icon class="image-list-button" @click.stop>
                <img src="~icons/download.svg"></img>
              </v-btn>
            </a>
          </span>
        </div>
      </v-tab-item>

      <v-tab-item :id="`tasks`" class="body">
        <no-data-message v-if="projectTasks.length === 0">
          <v-icon slot="icon">event_note</v-icon>
          <div slot="message">
            There are no effort items to show
          </div>
          <div slot="sub-message">
            You can start by creating a new effort
          </div>
          <div slot="button">
            <router-link :to="{name: 'TasksNew'}">
              Create Effort
            </router-link>
          </div>
        </no-data-message>

        <v-list>
          <div v-for="task in projectTasks" class="list-border" :key="task.task_id">
            <div class="list-tile task-view">
              <v-list-tile-content>
                <span v-if="task.task_status === '3'" class="completed white--text">completed</span>
                <strike v-if="task.task_status === '3'" class="strike-text">{{ task.task_name }}</strike>
                <router-link v-else :to="{name: 'TaskDetails', params: {id: task.task_id }}">
                  {{ task.task_name }}
                </router-link>
              </v-list-tile-content>
            </div>
          </div>
        </v-list>
      </v-tab-item>

      <v-tab-item  :id="`chat`">
        <v-container fluid class="pa-0">
          <v-layout class="unset-center fixed-channels">
            <v-flex xs12>
              <v-btn-toggle mandatory class="btn-toggle-project" v-model="activeChannel">
                <v-btn :disabled = "isChannelAccessBlocked('organizers')" @click="changeActiveChannel('organizers')" value="organizers" class="pa-0">
                  #Organizers
                </v-btn>
                <v-btn :disabled = "isChannelAccessBlocked('contributors')" @click="changeActiveChannel('contributors')" value="contributors" class="pa-0">
                  #Contributors
                </v-btn>
                <v-btn :disabled = "isChannelAccessBlocked('prospects')" @click="changeActiveChannel('prospects')" value="prospects" class="pa-0">
                  #Prospects
                </v-btn>
              </v-btn-toggle>
            </v-flex>
          </v-layout>
        </v-container>
        <v-layout column class="body white fixed-body chat-body" @scroll="onChatScroll" ref="chats">
          <span v-if="fetchingChats" class="chat-loader-holder pt-4"><loader class="half-circle-spinner-chat"></loader></span>
          <v-list dense class="list-container">
            <template v-for="(item, index) in messages">
              <div class="list-tile"  :key="item.msg_id" :id="item.msg_id">
                <v-list-tile-avatar>
                  <img v-if="getAvatar(item.user_id)" :src="getAvatar(item.user_id)" :alt="getUserName(item.user_id).charAt(0)">
                  <v-avatar size="40px" v-else class="red">
                    <span class="headline white--text">{{ getUserName(item.user_id).charAt(0).toUpperCase() }}</span>
                  </v-avatar>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <div class="title-date-div">
                    <router-link class="project-owner-text" :to="{ name: 'UserProfile', params: {id: item.user_id}, query: { ref_project_id: id } }">
                      {{ getUserName(item.user_id) }}
                    </router-link>
                    <span class="date-text"> {{ getTime(item.time_f) }}</span>
                  </div>
                  <!-- <img v-if="index%2 !== 0" src= "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTTlk9PtXEraeyw5bI7xb1cvCo2oTw6WTRQQpZ2EJlRtwYVwMAz" height="120px" width="162px"></img> -->
                  <span>{{ item.value | unescape }}</span>
                </v-list-tile-content>
              </div>
            </template>
            <transition name="fade">
              <div  @click="scrollToTop()"
                v-if="showScrollUp"
                id="scroll-up">
                <v-icon class="upIcon">arrow_upward</v-icon>
              </div>
            </transition>
          </v-list>
        </v-layout>
      </v-tab-item>
    </v-tabs-items>
    <div v-if= "activeTabbar === 'chat'" class="input-container-chat px-3" id="bottom-fixed">
      <v-text-field
        single-line
        type="text"
        placeholder="Type here..."
        v-model="message"
        @keyup.enter = "addChatMessage(message)"
      >
      </v-text-field>
    </div>
  </v-app>
</template>

<script>
import Imager from '@/components/Imager';
import Loader from '@/components/Loader';
import Topbar from '@/components/Topbar';
import VueMarkdown from 'vue-markdown';
import { get, uniqBy } from 'lodash';
// images
import audioThumbnail from 'icons/audio-thumbnail.png';
import videoThumbnail from 'icons/video-thumbnail.png';
import documentThumbnail from 'icons/document-thumbnail.png';
import { identifyFileType, FILE_TYPES } from '@/utils/file_type';
import { getChatsViaSocket, addChatMessageViaSocket } from '@/api';

import moment from 'moment';

export default {
  components: {
    Imager,
    Loader,
    Topbar,
    VueMarkdown,
  },
  data() {
    return {
      message: null,
      contributors: [],
      messages: [],
      timeRange: {},
      fetchingChats: false,
      activeChannel: null,
      userIdPresent: false,
      showScrollUp: false,
      channelCode: null,
    };
  },
  methods: {
    changeActiveChannel(value) {
      // make the messages and timeRange empty on each press
      this.channelCode = null;
      this.messages = [];
      this.timeRange = {};
      this.fetchChats(value, true);
      this.$router.replace({ ...this.$route, query: { scope: value } });
    },
    scrollToTop() {
      this.$refs.chats.scrollTop = 0;
    },
    showGallery(index) {
      this.$store.dispatch('gallery/showGallery', { show: true, active: index });
    },
    onChatScroll(e) {
      const offsetTop = e.target.scrollTop;
      if (offsetTop === 0) {
        const id = document.getElementById(get(this.messages, '[0].msg_id'));
        this.fetchChats(this.activeChannel);
        if (id && this.timeRange.max_time !== '0' && this.timeRange.min_time !== '0') {
          id.scrollIntoView();
        }
      }
      if (offsetTop < 25) {
        this.showScrollUp = false;
      } else {
        this.showScrollUp = true;
      }
    },
    getTime(item) {
      const time = moment(item).format('MMM D, hh:mm a');
      return time;
    },
    isChannelAccessBlocked(value) {
      if (this.allowedChannelAccess.length === 0) return false;
      for (let i = 0; i < this.allowedChannelAccess.length; i += 1) {
        if (this.allowedChannelAccess[i] === value) {
          return false;
        }
      }
      return true;
    },
    goBack() {
      this.$router.go(-1);
    },
    addChatMessage(message) {
      if (!message || message.trim().length === 0) return;
      const userToken = this.$store.getters['auth/userToken'];
      const values = {
        chat_channel_area: 'project',
        chat_channel_scope: this.activeChannel,
        project_id: this.id,
        msg: message,
      };

      this.message = null;
      this.isNewMessage = true;
      addChatMessageViaSocket(userToken, values, this.handleChatResponse);
    },
    handleChatResponse(response) {
      const data = JSON.parse(response.data);
      const messageChannel = get(data, '[1].data.details.channel_info.chat_channel_code');
      this.channelCode = this.channelCode || messageChannel;

      if (this.channelCode !== messageChannel) {
        return;
      }

      const timeRange = get(data, '[1].data.details.timerange', {});
      this.timeRange = timeRange;
      this.fetchingChats = false;

      // extract contributors, merge them, keep unique
      let contributors = get(data, '[1].data.details.contributors.details', []);
      contributors = [...contributors, ...this.contributors];
      this.contributors = uniqBy(contributors, 'user_id');

      // in time range min or max is 0 then no need to update other items
      if (this.timeRange.min_time === '0' || this.timeRange.max_time === '0') return;

      // extract the message, merge it, only keep uniq ones
      let messages = get(data, '[1].data.details.messages', []);
      messages = [...messages, ...this.messages];
      messages = uniqBy(messages, 'msg_id');
      this.messages = this.sortByDate(messages, 'time_f');
    },
    fetchChats(channelScope, showLatest) {
      const userToken = this.$store.getters['auth/userToken'];
      const minTime = this.timeRange.min_time;

      if (minTime === '0') return;
      this.fetchingChats = true;
      const values = {
        chat_channel_area: 'project',
        chat_channel_scope: channelScope,
        project_id: this.id,
        before_time: minTime,
      };
      getChatsViaSocket(userToken, values, (response) => {
        this.handleChatResponse(response);

        this.$nextTick(() => {
          if (showLatest) {
            this.scrollBottom();
          }
        });
      });
    },

    scrollBottom() {
      const chatBox = this.$refs.chats;
      chatBox.scrollTop = chatBox.scrollHeight;
    },
    getAvatar(userId) {
      if (!userId) return null;

      let avatar = null;
      for (let i = 0; i < this.contributors.length; i += 1) {
        if (userId === this.contributors[i].user_id) {
          avatar = this.contributors[i].avatar;
        }
      }

      return avatar;
    },
    getUserName(userId) {
      if (!userId) return null;

      let username = '';
      for (let i = 0; i < this.contributors.length; i += 1) {
        if (userId === this.contributors[i].user_id) {
          username = this.contributors[i].username;
        }
      }
      return username;
    },
    createThumbnailUrl(url) {
      /* eslint global-require: "warn" */
      const fileType = identifyFileType(url);
      switch (fileType) {
        case FILE_TYPES.IMAGE:
          return url;
        case FILE_TYPES.VIDEO:
          return videoThumbnail;
        case FILE_TYPES.AUDIO:
          return audioThumbnail;
        default:
          return documentThumbnail;
      }
    },
    sortByDate(messageArray, dateKey) {
      return messageArray.sort((a, b) => (a[dateKey] > b[dateKey] ? 1 : -1));
    },
    setActiveChannel() {
      const scope = this.$route.query.scope;
      if (scope) {
        this.activeChannel = scope;
        return;
      }

      if (this.allowedChannelAccess.length === 0) {
        this.activeChannel = null;
      } else if (this.allowedChannelAccess.includes('organizers')) {
        this.activeChannel = 'organizers';
      } else if (this.allowedChannelAccess.includes('contributors')) {
        this.activeChannel = 'contributors';
      } else if (this.allowedChannelAccess.includes('prospects')) {
        this.activeChannel = 'prospects';
      }
    },
  },
  computed: {
    allowedChannelAccess() {
      // user has access to which channels
      return this.$store.getters['projects/allowedChannelAccess'];
    },

    userId() {
      return this.$store.getters['auth/userId'];
    },

    userInContributors() {
      if (this.contributors.length === 0) return false;
      // checks if the current user is in the contributor list;
      // before adding chat if the user id is not in the contributr
      for (let i = 0; i < this.contributors.length; i += 1) {
        if (this.contributors[i].user_id === this.userId) {
          return true;
        }
      }
      return false;
    },

    id() {
      return this.$route.params.id;
    },
    projectMedia: {
      get() {
        const images = this.$store.getters['projects/medias'];
        const imageUrls = [];
        for (let i = 0; i < images.length; i += 1) {
          imageUrls.push(images[i].data_url);
        }
        this.$store.dispatch('gallery/setImages', imageUrls);
        return images;
      },
    },
    projectTasks: {
      get() { return this.$store.getters['projects/projectTasks']; },
    },
    project() {
      return this.$store.getters['projects/project'];
    },
    activeTabbar() {
      return this.$route.meta.query.activeTabbar || 'overview';
    },
  },
  watch: {
    activeTabbar(value) {
      if (value === 'chat') this.$nextTick(this.scrollBottom);
    },
  },
  mounted() {
    this.$store.dispatch('projects/getProjectDetails', { projectId: this.id }).then(() => {
      // setActiveChannel function will help to toggle the btn with most priority
      this.setActiveChannel();
      this.fetchChats(this.activeChannel, true);
    });
    this.$store.dispatch('projects/getProjectsTasks', { projectId: this.id });
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/shared.scss";
#app {
  #bottom-fixed {
    z-index: 40;
  }
  .list-container {
    display: flex;
    flex-direction: column;
    margin-top: auto;
  }
  .chat-body {
    // css to make the chat start from bottom
    display: flex;
    height: auto;
    flex-direction: column;
  }

  .chat-body::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    background-color: #F5F5F5;
  }

  .chat-body::-webkit-scrollbar {
    width: 6px;
    background-color: #F5F5F5;
  }

  .chat-body::-webkit-scrollbar-thumb {
    background-color: #b2bac2;
  }

  .fixed-top .toolbar__title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  // these are all for large screen adapt them for other screen sized
  @media only screen and (max-width: 599px) {
    .fixed-nav {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 1;
    }

    .fixed-top {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 33;
    }

    .fixed-channels {
      position: fixed;
      top: 110px;
      right: 0;
      left: 0;
      bottom: 65px;
      z-index: 35;
    }

    .fixed-body {
      position: fixed;
      top: 150px;
      right: 0;
      left: 0;
      bottom: 65px;
      overflow-y: scroll;
      z-index: 35;
    }
  }

  @media only screen and (min-width: 600px) and (max-width: 1600px) {
    // fix the top navbar as well
    .fixed-nav {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 1;
    }

    .fixed-top {
      position: fixed;
      top: 50px;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 33;
    }

    .fixed-channels {
      position: fixed;
      top: 165px;
      right: 0;
      left: 0;
      bottom: 65px;
      z-index: 35;
    }

    .fixed-body {
      position: fixed;
      top: 220px;
      right: 0;
      left: 0;
      bottom: 65px;
      overflow-y: scroll;
      z-index: 35;
    }
  }


  @media only screen and (min-width: 1600px) {
    .fixed-top {
      z-index: 20;
      position: fixed;
      left: 300px;
      width: calc(100vw - 300px);
    }

    .fixed-channels {
      position: fixed;
      top: 115px;
      right: 0;
      left: 300px;
      bottom: 65px;
      z-index: 35;
    }

    .fixed-body {
      z-index: 40;
      position: fixed;
      top: 165px;
      right: 0;
      bottom: 50px;
      left: 300px;
      overflow-y: scroll;
      width: calc(100vw - 320px);
    }
  }

    .chat-loader-holder {
      align-self: center;
    }
    .unset-center {
      text-align: center;
    }
    .body {
      padding-top: 20px;
      padding-left: 29px;
      padding-right: 29px;
      padding-bottom: 10px;
    }

    .title-date-div {
      width: 100%;
    }

    .half-circle-spinner-chat {
      width: 30px;
      height: 30px;
      margin: 0px;
    }
    .appear {
      position: fixed;
      right: 24px;
      bottom: 73px;
      display: none;
    }
    .show {
      display: inherit;
    }
    .task-view {
      .list__tile__content {
        color: $blue;
        font-size: 16px;
        span {
          font-size: 10px;
        }
        div {
          font-size: 16px;
          color: $blue;
        }
        .strike-text {
          color: $header;
        }
      }
    }
    .left-contributors {
      border-radius: 50%;
      border: 2px solid white;
      background: $blue;
      height: 40px;
      margin-left: -7px;
      text-align: center;
      width: 40px;
      span {
        position: relative;
        top: 2px;
        left: 2px;
      }
    }
    .contributors-area {
      span {
        margin-left: -7px;
        font-size: 20px;
      }
      img {
        height: 40px;
        width: 40px;
        border-radius: 50%;
        border: 2px solid white;
      }
    }
    .status{
      border-radius:3px;
      padding: 3px;
      color: white;
    }
    .completed {
      background: #6fae36;
    }
    .edit {
      margin-top: auto;
      margin-left: -7px;
      margin-top: 12px;
      margin-bottom: 16px;
      span {
        font-size: 13px;
        font-family: MuseoSans-500;
        color: $blue;
      }
    }
    .all-contributors-btn {
      span {
        font-size: 16px;
        font-family: MuseoSans-500;
        color: $blue;
      }
    }
    .project-description {
      font-size: 14px;
      word-wrap: break-word;
    }

    .toolbar__title {
      padding-left: 10px;
      padding-right: 10px;
      text-align: center;
      white-space: initial;
      font-weight: bold;
      word-break: break-word;
      margin-left: 0px;
      margin-top: 10px;
    }

    .project-owner-text {
      color: $blue;
    }
    .date-text {
      float: right;
      color: $header;
      font-size: 12px;
    }

    .title {
      color: $blue;
      font-size: 16px;
    }

    .list-tile {
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      color: inherit;
      min-height: 48px;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      font-size: 16px;
      font-weight: 400;
      min-height: 75px;
      height: auto;
      margin: 0;
      padding-top: 14px;
      padding-bottom: 14px;
      position: relative;
      text-decoration: none;
      -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      border-bottom: 1px solid $lighter;
    }

    .list__tile__avatar {
      margin-bottom: auto;
    }

    .image-list {
      position: relative;
      display:inline-block;
      padding:1px;
    }

    .image-list .image-list-button {
      background: $white;
      position: absolute;
      right: 0;
      bottom: 0;
      margin-right: 10px;
      margin-bottom: 10px;
    }
    .list .list__tile__sub-title, .application .theme--light.list .list__tile__sub-title {
      font-size:13px;
      white-space: inherit;
      word-break: break-word;
    }
    .list .list__tile__title, .application .theme--light.list .list__tile__title {
      color: $blue;
      font-size: 16px;
    }

    .extended-toolbar {
      padding:4px;
      background: linear-gradient(to right, rgb(255,214,119) , rgb(255,46,100));
      color: white;
      line-height: 2;
      height: 75px;
      margin-bottom: -4px;
      margin-top: -2px;
    }

    .follow-project {
      background: transparent;
      width: 20%;
      padding: 8px;
      height: auto;
      margin-bottom: 24px;
      border-radius: 24px 24px 24px 24px;
      background-color: white;
      box-shadow: none;
      color: $blue;
      .btn__content {
           opacity: 0;
        }
    }

    a {
      text-decoration: none;
    }

    @media only screen and (min-width: 1101px) {
      .btn-toggle-project.btn-toggle {
        width: 70%;
        margin: 0px;
        height: 35px;
        span {
          font-size: 20px;
        }
      }
    }
    @media only screen and (max-width: 1100px) {
      .btn-toggle-project.btn-toggle {
        width: 95%;
        margin: 0px;
        height: auto;
      }
    }

    .btn-toggle-project.btn-toggle {
      align-self: center;
      margin: 0px;
      margin-top: 10px;
      .btn.btn--active {
        background-color: $btn-toggle;
        color: white;
      }

      // all button css
      .btn {
        width: 100%;
        height: 100%;
        border: solid 1px $btn-toggle;
        padding-left: 2px !important;
        padding-right: 2px !important;
      }

      .btn:first-child {
        width: 100%;
        border-top-left-radius: 23px;
        border-bottom-left-radius: 23px;
      }

      .btn:last-child {
        width: 100%;
        border-top-right-radius: 23px;
        border-bottom-right-radius: 23px;
      }
    }
    .input-container-chat {
      position: fixed;
      bottom: 10px;
      border-color: $border-color;
      border-radius: 8px;
      padding:14px;
      background-color: #fbfbfb;
      box-shadow: 0 2px 6px 0 rgba(224, 153, 153, 0.5);
      input {
        width:100%;
      }
    }
    .input-container-chat input:focus, .input-container textarea:focus {
      outline: none;
      width: 100%;
    }
    @media only screen and (max-width: 800px) and (min-width: 410px){
      .follow-project {
        width: 40%;
      }
    }

    @media only screen and (max-width: 411px) {
      .input-container-chat {
        width: 91%;
        margin-left: 18px;
      }
      .follow-project {
        width:55%;
      }
    }

    @media only screen and (max-width:499px) and (min-width: 412px) {
      .input-container-chat {
        width: 91%;
        margin-left: 16px;
      }
    }

    @media only screen and (max-width:600px) and (min-width: 500px) {
      .input-container-chat {
        width: 94%;
        margin-left: 16px;
      }
    }

    @media only screen and (max-width:712px) and (min-width: 601px) {
      .input-container-chat {
        width: 94%;
        margin-left: 18px;
      }
    }

    @media only screen and (max-width:800px) and (min-width: 713px) {
      .input-container-chat {
        width: 96%;
        margin-left: 16px;
      }
    }

    @media only screen and (max-width:1024px) and (min-width: 801px) {
      .input-container-chat {
        width: 96%;
        margin-left: 16px;
      }
      .follow-project {
        width:20%;
      }
    }

    @media only screen and (max-width:1300px) and (min-width: 1025px) {
      .input-container-chat {
        width: 97%;
        margin-left: 16px;
      }
    }

    @media only screen and (max-width:1600px) and (min-width: 1301px) {
      .input-container-chat {
        width: 97%;
        margin-left: 20px;
      }
    }

    @media only screen and (max-width:1860px) and (min-width: 1601px) {
      .input-container-chat {
        width: 80%;
        margin-left: 22px;
      }
    }

    @media only screen and (max-width:1893px) and (min-width: 1861px) {
      .input-container-chat {
        width: 82%;
        margin-left: 19px;
      }
    }

    @media only screen and (max-width:2100px) and (min-width: 1894px) {
      .input-container-chat {
        width: 82%;
        margin-left: 19px;
      }
    }

    @media only screen and (max-width:2350px) and (min-width: 2101px) {
      .input-container-chat {
        width: 84%;
        margin-left: 17px;
      }
    }

    @media only screen and (max-width:2520px) and (min-width: 2351px) {
      .input-container-chat {
        width: 86%;
        margin-left: 14px;
      }
    }

    @media only screen and (max-width:2800px) and (min-width: 2521px) {
      .input-container-chat {
        width: 86%;
        margin-left: 22px;
      }
    }

    @media only screen and (max-width:3700px) and (min-width: 2801px) {
      .input-container-chat {
        width: 88%;
        margin-left: 17px;
      }
    }

    @media only screen and (max-width:5600px) and (min-width: 3701px) {
      .input-container-chat {
        width: 91%;
        margin-left: 17px;
      }
    }

    @media only screen and (max-width:7500px) and (min-width: 5601px) {
      .input-container-chat {
        width: 94%;
        margin-left: 17px;
      }
    }

    @media only screen and (min-width:7501px) {
      .input-container-chat {
        width: 95%;
        margin-left: 35px;
      }
    }

    @media only screen and (max-width: 800px) {
      .toolbar {
        padding-bottom: 20px;
        margin-bottom: -2px;
      }
    }

    @media only screen and (max-width: 800px) {
      .toolbar {
        padding-bottom: 20px;
        margin-bottom: -2px;
      }
    }
    @media only screen and (max-width: 600px) {
      .appear {
        bottom:130px;
      }
      .extended-toolbar {
        padding: 0px;
      }
      .toolbar {
        padding-top: 0px;
        padding-bottom: 0px;
        .toolbar__title {
          padding-top: 0px;
        }
      }
    }
    .list-border {
      min-height: 10px;
      border-bottom: 0px solid $lighter;
    }
    #scroll-up {
      position: fixed;
      right: 30px;
      bottom: 80px;
      z-index: 999;
      cursor:pointer;
    }

    .upIcon {
      color: $white;
      background: $primary;
      padding: 2px;
      border-radius: 100%;
    }

    .fade-enter-active, .fade-leave-active {
      transition: opacity 0.5s;
    }

    .fade-enter, .fade-leave-to {
      opacity: 0;
    }

    .project-name {
      font-size: 24px;
      font-weight: bold;
      font-family: 'MuseoSans-500';
      line-height: 1.2;
      margin-top: 10px;
      text-decoration: none;
      color: initial;
      margin-bottom: 10px;
    }

}
</style>



// WEBPACK FOOTER //
// src/components/ProjectDetails.vue